type NamedRecord = {
  firstName: string;
  lastName: string;
};
export const sortByName = (a: NamedRecord, b: NamedRecord) => {
  const nameA = [a.firstName, a.lastName]
    .filter((x) => x)
    .join(' ')
    .trim();
  const nameB = [b.firstName, b.lastName]
    .filter((x) => x)
    .join(' ')
    .trim();

  return nameA.localeCompare(nameB);
};
